import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Check } from 'lucide-react';
export function Contact() {
  const [showCopied, setShowCopied] = useState(false);
  const handlePhoneClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Fire Google Ads conversion event
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;
      (window as any).gtag('event', 'conversion', {
        send_to: 'AW-349742034/M8ECCPrSnrADENLH4qYB'
      });
    }
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) {
      e.preventDefault();
      const phoneNumber = '(818) 381-9905';
      navigator.clipboard.writeText(phoneNumber).then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
      }).catch(() => {
        window.location.href = 'tel:8183819905';
      });
    }
  };
  return <section className="w-full bg-gradient-to-b from-black to-zinc-950 py-20 px-4" id="contact" data-id="element-45" data-mp="bpcjspop33oi">
      <div className="max-w-5xl mx-auto text-center" data-id="element-46" data-mp="3jvb8iqvtkfdl">
        <h2 className="text-3xl md:text-5xl font-black uppercase text-white mb-2" data-id="element-47" data-mp="3jxnxvp3wps0o">
          Ready for a{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-600" data-id="element-48" data-mp="3owijszx67wp0">
            Showroom Shine?
          </span>
        </h2>
        <p className="text-gray-400 text-lg mb-8" data-id="element-49" data-mp="3f3bdnculwcnv">
          Book your mobile car detailing appointment today — serving Camarillo,
          Oxnard, Ventura, Thousand Oaks, Simi Valley and all of Ventura County
        </p>

        <div className="flex flex-col items-center gap-8" data-id="element-50" data-mp="3623gwz7qnjvw">
          <a href="tel:8183819905" onClick={handlePhoneClick} className="group relative flex flex-col items-center justify-center w-full max-w-full p-6 sm:p-8 md:p-12 bg-zinc-900 border-2 border-red-600 rounded-2xl hover:bg-zinc-800 transition-all duration-300 shadow-[0_0_40px_-10px_rgba(220,38,38,0.3)] hover:shadow-[0_0_60px_-10px_rgba(220,38,38,0.5)] cursor-pointer" aria-label="Call Mike's Pro Detail" data-id="element-51" data-mp="2s5gggmgkubl8">
            <span className="text-base sm:text-xl md:text-2xl text-gray-400 uppercase tracking-widest mb-2 font-bold text-center" data-id="element-52" data-mp="23cdhrhe9hklg">
              Call or Text Mike
            </span>
            <div className="flex items-center gap-2 sm:gap-3 md:gap-6" data-id="element-53" data-mp="1ubxd44ls87f0">
              <Phone className="w-6 h-6 sm:w-8 sm:h-8 md:w-12 md:h-12 shrink-0 text-red-500 fill-red-500/20" data-id="element-54" data-mp="1pc2ns5hnnpw2" />
              <span className="text-[28px] sm:text-4xl md:text-6xl lg:text-7xl font-black text-white tracking-tighter whitespace-nowrap group-hover:scale-105 transition-transform" data-id="element-55" data-mp="2m2lbx9zzh0pi">
                (818) 381-9905
              </span>
            </div>
            <div className="absolute -bottom-4 bg-black px-4 py-1 border border-zinc-800 rounded-full" data-id="element-56" data-mp="2d7x5hgio9cz4">
              <span className="text-green-500 font-bold uppercase text-sm flex items-center gap-2" data-id="element-57" data-mp="288kld3j6qk08">
                <span className="relative flex h-3 w-3" data-id="element-58" data-mp="35s5kqkg2m8xj">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-59" data-mp="30yb27kc7c001"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" data-id="element-60" data-mp="38cblkj9e1j9v"></span>
                </span>
                Available Now
              </span>
            </div>
          </a>

          {/* Copied to clipboard toast */}
          {showCopied && <div className="fixed top-8 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-3 bg-green-600 text-white rounded-lg shadow-lg animate-in fade-in slide-in-from-top-2 duration-300" data-id="element-61" data-mp="3maicfffx6j01">
              <Check className="w-5 h-5" data-id="element-62" data-mp="20axthpje00" />
              <span className="font-semibold" data-id="element-63" data-mp="yxjid7yff4">
                Phone number copied to clipboard!
              </span>
            </div>}

          {/* Footer navigation: internal + external links */}
          <footer className="mt-12 pt-8 border-t border-zinc-900 w-full text-gray-500 text-sm" data-id="element-64" data-mp="9uxwy9lwrl3d">
            <nav aria-label="Footer navigation" data-id="element-65" data-mp="dsdjny2fawqe">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-left mb-8" data-id="element-66" data-mp="isrt9kjoaeqj">
              {/* Services */}
              <div data-id="element-67" data-mp="55rfccizstyq">
                <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-3" data-id="element-68" data-mp="559h5acrs5o6">
                  Detailing Services
                </h3>
                <ul className="space-y-2" data-id="element-69" data-mp="ex5jixlw2hy7">
                  <li data-id="element-70" data-mp="ew48uu8sbxh0">
                    <Link to="/services/mobile-detailing" className="hover:text-yellow-400 transition-colors" data-id="element-71" data-mp="eygmwwbf9nos">
                      Mobile Detailing
                    </Link>
                  </li>
                  <li data-id="element-72" data-mp="3if5vsoyh99hm">
                    <Link to="/services/interior-detailing" className="hover:text-yellow-400 transition-colors" data-id="element-73" data-mp="3ec0v8rxyjhvm">
                      Interior Detailing
                    </Link>
                  </li>
                  <li data-id="element-74" data-mp="3ncpbltatpubo">
                    <Link to="/services/exterior-detailing" className="hover:text-yellow-400 transition-colors" data-id="element-75" data-mp="3nbe3xie9c2fa">
                      Exterior Detailing
                    </Link>
                  </li>
                  <li data-id="element-76" data-mp="12l5bu1yumgew">
                    <Link to="/services/full-car-detail" className="hover:text-yellow-400 transition-colors" data-id="element-77" data-mp="12lyjr69jnbym">
                      Full Car Detail
                    </Link>
                  </li>
                  <li data-id="element-78" data-mp="2pk7ri3777iy9">
                    <Link to="/services/hybrid-ceramic-spray" className="hover:text-yellow-400 transition-colors" data-id="element-79" data-mp="2pgjyd55o0yk2">
                      Hybrid Ceramic Spray
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Service areas */}
              <div data-id="element-80" data-mp="349x733g1fpi2">
                <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-3" data-id="element-81" data-mp="389ecxxzdmonr">
                  Service Areas
                </h3>
                <ul className="space-y-2" data-id="element-82" data-mp="2ugy2wd825qdc">
                  <li data-id="element-83" data-mp="2ug6kk43h1p50">
                    <Link to="/mobile-detailing-camarillo" className="hover:text-yellow-400 transition-colors" data-id="element-84" data-mp="2zgu7oeokxlty">
                      Camarillo
                    </Link>
                  </li>
                  <li data-id="element-85" data-mp="3rx50an06z83q">
                    <Link to="/mobile-detailing-oxnard" className="hover:text-yellow-400 transition-colors" data-id="element-86" data-mp="3rxn2s1dg6ik3">
                      Oxnard
                    </Link>
                  </li>
                  <li data-id="element-87" data-mp="od7ps0r20lz">
                    <Link to="/mobile-detailing-ventura" className="hover:text-yellow-400 transition-colors" data-id="element-88" data-mp="q7s9583zqpj">
                      Ventura
                    </Link>
                  </li>
                  <li data-id="element-89" data-mp="3mv30uo8m3iog">
                    <Link to="/mobile-detailing-thousand-oaks" className="hover:text-yellow-400 transition-colors" data-id="element-90" data-mp="3mvl4w71in16x">
                      Thousand Oaks
                    </Link>
                  </li>
                  <li data-id="element-91" data-mp="3e287oswf5df1">
                    <Link to="/mobile-detailing-simi-valley" className="hover:text-yellow-400 transition-colors" data-id="element-92" data-mp="3e1ye6vc60o4l">
                      Simi Valley
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Find us online (external links) */}
              <div data-id="element-93" data-mp="2z8mr5h4s67cp">
                <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-3" data-id="element-94" data-mp="2v4x44w3r7xts">
                  Find Us Online
                </h3>
                <ul className="space-y-2" data-id="element-95" data-mp="1am4hpmx6itao">
                  <li data-id="element-96" data-mp="1ap8xzinx5fhp">
                    <a href="https://www.google.com/maps/search/Full+Detail+Pro+Ventura+County" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors" data-id="element-97" data-mp="1enyg1ojwjl7o">
                      Google Maps &amp; Reviews
                    </a>
                  </li>
                  <li data-id="element-98" data-mp="qyx0zigkdbtf">
                    <a href="https://www.bbb.org/search?find_text=Full+Detail+Pro&find_loc=Ventura+County%2C+CA" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors" data-id="element-99" data-mp="qzopk9bqu9a7">
                      Better Business Bureau
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            </nav>

            <div className="pt-6 border-t border-zinc-900 flex flex-col md:flex-row justify-between items-center gap-2 text-gray-600" data-id="element-100" data-mp="88p59lf71nn9">
              <p data-id="element-101" data-mp="d6gxyhnnxdsi">
                © {new Date().getFullYear()} Mike's Pro Detail — Mobile Car
                Detailing in Ventura County, California. All rights reserved.
              </p>
              <p data-id="element-102" data-mp="2xr937uamk437">
                <a href="/#services" className="hover:text-gray-400 transition-colors" data-id="element-103" data-mp="2xrsmbec0gyit">
                  Services
                </a>
                {' · '}
                <a href="/#service-areas" className="hover:text-gray-400 transition-colors" data-id="element-104" data-mp="36rfj1mtspg5j">
                  Service Areas
                </a>
                {' · '}
                <Link to="/faq" className="hover:text-gray-400 transition-colors" data-id="element-105" data-mp="3lmbyol3xp5sn">
                  FAQ
                </Link>
              </p>
            </div>
          </footer>
        </div>
      </div>
    </section>;
}